import MUISportsSoccer from '@mui/icons-material/SportsSoccer'

export const SportsSoccerIcon = MUISportsSoccer
